import React, { useCallback } from 'react';

import { FlexRow } from 'ui-components/components/flex';
import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { useDrawerContext } from 'ui-components/components/drawer/context';

import { useAdvancedShippingNoticeContext } from '../../advanced-shipping-notice-context';
import { useModal } from '../../../../../../../hooks/use-modal';
import { ConfirmDialogueModal } from '../../../../../../../components/modals/confirm-dialogue-modal';

import { messages } from './messages';
import styles from './submit-asn-banner.module.less';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';

export const SubmitAsnBanner = () => {
  const { onClose } = useDrawerContext();
  const { onSubmitAsn, isSubmittingASN, isCompleteAllSteps, isDraft, isLoadingWarehouses } = useAdvancedShippingNoticeContext();
  const shouldDisableSubmit = !isCompleteAllSteps || isSubmittingASN || isLoadingWarehouses;
  const { isOpen, open, close } = useModal();
  const onConfirmSubmit = useCallback(async () => {
    await onSubmitAsn(close);
  }, [close, onSubmitAsn]);

  if (!isDraft) {
    return null;
  }

  return (
    <FlexRow className={styles['banner-container']}>
      <Button className={styles['close-button']} disabled={isSubmittingASN} onClick={onClose} theme='link'>
        <Text textType={TextType.Caption} value={messages.submitAsnBannerCloseButtonText} />
      </Button>
      <Button className={styles['submit-button']} disabled={shouldDisableSubmit} onClick={open} theme='primary'>
        <Text textType={TextType.Caption} value={messages.submitAsnBannerSubmitButtonText} />
      </Button>
      {isOpen && (
        <ConfirmDialogueModal
          body={
            !isSubmittingASN ? (
              <Text textType={TextType.Paragraph} value={messages.confirmSubmitBody} />
            ) : (
              <LoadingIndicator className={styles['loading-indicator']} />
            )
          }
          buttonDisabled={shouldDisableSubmit}
          header={<Text textType={TextType.Paragraph} value={messages.confirmSubmitHeader} />}
          onClose={close}
          onConfirm={onConfirmSubmit}
        />
      )}
    </FlexRow>
  );
};
